/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplierBatchDto } from './SupplierBatchDto';
import {
    SupplierBatchDtoFromJSON,
    SupplierBatchDtoFromJSONTyped,
    SupplierBatchDtoToJSON,
} from './SupplierBatchDto';

/**
 * 
 * @export
 * @interface CreateSourcingBatchesResponseDto
 */
export interface CreateSourcingBatchesResponseDto {
    /**
     * 
     * @type {Array<SupplierBatchDto>}
     * @memberof CreateSourcingBatchesResponseDto
     */
    batches: Array<SupplierBatchDto>;
    /**
     * 
     * @type {number}
     * @memberof CreateSourcingBatchesResponseDto
     */
    batchCount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSourcingBatchesResponseDto
     */
    itemCount: number;
    /**
     * OrderItem IDs that could not be batched because supplierId is null. Surface as a warning in the UI.
     * @type {Array<number>}
     * @memberof CreateSourcingBatchesResponseDto
     */
    unbatchedOrderItemIds: Array<number>;
    /**
     * OrderItem IDs skipped because they were already part of an open batch.
     * @type {Array<number>}
     * @memberof CreateSourcingBatchesResponseDto
     */
    skippedOrderItemIds: Array<number>;
}

/**
 * Check if a given object implements the CreateSourcingBatchesResponseDto interface.
 */
export function instanceOfCreateSourcingBatchesResponseDto(value: object): value is CreateSourcingBatchesResponseDto {
    if (!('batches' in value) || value['batches'] === undefined) return false;
    if (!('batchCount' in value) || value['batchCount'] === undefined) return false;
    if (!('itemCount' in value) || value['itemCount'] === undefined) return false;
    if (!('unbatchedOrderItemIds' in value) || value['unbatchedOrderItemIds'] === undefined) return false;
    if (!('skippedOrderItemIds' in value) || value['skippedOrderItemIds'] === undefined) return false;
    return true;
}

export function CreateSourcingBatchesResponseDtoFromJSON(json: any): CreateSourcingBatchesResponseDto {
    return CreateSourcingBatchesResponseDtoFromJSONTyped(json, false);
}

export function CreateSourcingBatchesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSourcingBatchesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'batches': ((json['batches'] as Array<any>).map(SupplierBatchDtoFromJSON)),
        'batchCount': json['batchCount'],
        'itemCount': json['itemCount'],
        'unbatchedOrderItemIds': json['unbatchedOrderItemIds'],
        'skippedOrderItemIds': json['skippedOrderItemIds'],
    };
}

export function CreateSourcingBatchesResponseDtoToJSON(value?: CreateSourcingBatchesResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'batches': ((value['batches'] as Array<any>).map(SupplierBatchDtoToJSON)),
        'batchCount': value['batchCount'],
        'itemCount': value['itemCount'],
        'unbatchedOrderItemIds': value['unbatchedOrderItemIds'],
        'skippedOrderItemIds': value['skippedOrderItemIds'],
    };
}

